<template>
<MainLayout501 selectMenu="1-1" sideBar="machine" siderMenu="501-7">
    <Tabs v-model="selectTab" type="card" class="custom-tabs">
        <TabPane :label="getTranslation('a115')" name="m1" class="custom-tabpane">
            <HardWare :systemData="systemData" :mac="mac" @save="handleSave"></HardWare>
        </TabPane>
        <TabPane :label="getTranslation('a116')" name="m2" class="custom-tabpane">
            <FunctionSetting :systemData="systemData" :mac="mac" @save="handleSave"></FunctionSetting>
        </TabPane>
        <TabPane :label="getTranslation('a117')" name="m3" class="custom-tabpane">
            <CommunicationSetting :systemData="systemData" :mac="mac" @save="handleSave"></CommunicationSetting>
        </TabPane>
        <TabPane :label="getTranslation('a118')" name="m4" class="custom-tabpane">
            <JustifyParam :systemData="systemData" :mac="mac" @save="handleSave"></JustifyParam>
        </TabPane>
        <TabPane :label="getTranslation('a119')" name="m5" class="custom-tabpane">
            <SystemInfo :systemData="systemData" :mac="mac" @save="handleSave"></SystemInfo>
        </TabPane>
    </Tabs>
</MainLayout501>
</template>

<script>
import MainLayout501 from '@/components/501/MainLayout.vue'
import HardWare from './components/HardWare.vue'
import FunctionSetting from './components/FunctionSetting.vue'
import CommunicationSetting from './components/CommunicationSetting.vue'
import SystemInfo from './components/SystemInfo.vue'
import JustifyParam from './components/JustifyParam.vue'

import axios from 'axios';
import {
    API_URL
} from '@/constants/const'
import {
    mapGetters
} from 'vuex'
import { postJsError } from '@/util/util.js'
export default {
    name: 'SettingIndex',
    components: {
        MainLayout501,HardWare,FunctionSetting,CommunicationSetting,SystemInfo,JustifyParam
    },
    data() {
        return {
            systemData: {},            
            selectTab:"m1",
            mac:'',
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),  
    },
    watch: {
        selectTab(newVal) {            
            if(newVal){
                localStorage.setItem('system501.selectTab', newVal);
            }
        }
    },
    mounted() {
    },
    beforeDestroy() {
       
    },
    async created() {
      this.mac = this.$route.query.mac
      this.init();
    },
    methods: {  
        async init(){
            this.selectTab = localStorage.getItem('system501.selectTab') || 'm1';
            const url = API_URL['501SystemGet'];
            let params={
              mac :this.mac
            }
            let res = await axios.get(url, {
                    params: params
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
            if (res && res.data && res.data.code == 200) {
                if(res.data.data.param){
                  for(var i in res.data.data.param){
                    this.$set(this.systemData, i, res.data.data.param[i])
                  }
                }
            } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }
        },

        async handleSave(payload) {
           let formData = new FormData();
            formData.append('mac', this.mac);
            formData.append('param', JSON.stringify(payload));
            var res = await axios.post(API_URL['501SystemDownload'], formData).catch((err) => {
                postJsError(err)
                this.$Message.error(this.getTranslation('c001'))
            })
            if (res && res.data && res.data.code == 200) {
                this.$Message.success(res.data.hint || this.getTranslation('b125'))
                await this.init()
            } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg)
            } else {
                this.$Message.error(this.getTranslation('c001'))
            }
        },
        
       
    }
}
</script>

<style scoped>

</style>
